import { StreamData } from 'types/streamData'
import { setMarkers } from 'utils/rtlTextUtil'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const titleResolver: FieldResolver = (metadata: Metadata) =>
  ({ title: setMarkers(metadata.getTitle()) } as StreamData)

export default titleResolver
